import React, { useRef } from 'react'
import PrimaryTitle from '../../../../components/PrimaryTitle'
import { inject, observer } from 'mobx-react'
import { Input, Checkbox, DateInput, ImageUploader } from '../../../../components/formComponents'
import { Form, Button } from 'react-bootstrap'
import DocumentStore from '../../../../store/documentForm.store'
import PropTypes from 'prop-types'
import t from '../../../../service/translate.service'
import ContractSelector from '../../../../components/contractSelector'
import resizer from 'react-image-file-resizer'
import { buildValidators } from '../../../../service/validate'
import { Alert } from 'antd'
import { useNavigate } from 'react-router-dom'

const Fixtures = (props) => {
  const inputRefs = useRef({})
  const { model, setVal, tenantInstallationsValidators, tenantInstalationFiles, fileUploadError, tenantInstallationsValidatorInputs, errorsList, errorListVoice, submitted  } = DocumentStore
  const { file } = props
  const validatorBlur = buildValidators(tenantInstallationsValidatorInputs, true)
  const navigate = useNavigate()

  const generateErrorList = () => {
    const errors = []
    for (let key in inputRefs?.current) {
      const item = inputRefs?.current[key]
      if (key === 'date') {
        if (validatorBlur[key] && validatorBlur[key](item?.props?.selected, item?.props['aria-label'])) {
          let err = validatorBlur[key](item?.props?.selected, item?.props['aria-label'])
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.setFocus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      } else {
        if (validatorBlur[key] && validatorBlur[key](item.value, item.ariaLabel)) {

          let err = validatorBlur[key](item.value, item.ariaLabel)
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.focus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      }       
    }
    return errors
  }

  const resizeFile = (file) =>
    new Promise((resolve) => {
      resizer.imageFileResizer(file, 1600, 1600, 'jpeg', 90, 0,
        (uri) => {
          resolve(uri)
        },
        'file'
      )
    })

  const onImageDrop = async (files) => {
    const resizedImg = files.map(async (file) => {
      if (file.type === 'application/pdf') {
        return file
      }
      const image = await resizeFile(file)
      image.preview = file.preview
      return image
    })
    const resized = await Promise.all(resizedImg)
    DocumentStore.addFile(resized)
  }
  const onSubmit = async (e) => {
    e.preventDefault()
    DocumentStore.submit(file.fileName, props.contractStore.selectedContract.contractNumber, generateErrorList)
  }
  const getAttrs = field => {
    return {
      value: model[field],
      onChange: e => setVal(field, e.target.value),
      validate: tenantInstallationsValidators[field],
      blurValidate: validatorBlur[field]
    }
  }

  const AlertContent = () => {
    if (errorsList?.length > 0) {
      if (props?.documentFormHolderRef) {
        props.documentFormHolderRef?.current?.scrollTo(0,0)
      }
      return (
        <Alert
          role={errorListVoice ? "alert" : "none"}
          message={
            <div
              className='error-list'
              role={errorListVoice ? "alert" : "none"}
              aria-live={errorListVoice ? "assertive" : "off"}
            >
              {t.REQUIRED_FIELD_MISSING}
              {errorsList?.map((err) => {
                return err
              })}
            </div>
          }
          type='error'
          style={{ marginTop: '12px', marginBottom: '12px' }}
        />
      )
    } else {
      return (<></>)
    }
  }

  return (
    <div className='form-holder'>
      <PrimaryTitle title={t.FIXTURES} />
      {submitted && (
        <AlertContent />
      )}
      <Form>
        <ContractSelector required={true} label padding page='documents' aria-label={t.SELECT_CONTRACT} />
        <h3 className='inputs-text'>{t.FIXTURES_HEAD_ONE}</h3>
  
        <Input
          ref={(el) => (inputRefs.current['fixturesDesignation'] = el)}
          name='description' 
          {...getAttrs('fixturesDesignation')} 
          label={t.DIGITAL_CONTRACT_FORM_DESIGNATION + '*'} 
          aria-label={t.DESIGNATION}
        />
        <p className='inputs-text'>{t.DIGITAL_CONTRACT_DESCRIPTION_DESIGNATION}</p>
  
        <Input 
          ref={(el) => (inputRefs.current['fixturesScope'] = el)}
          name='scope' 
          {...getAttrs('fixturesScope')} 
          label={t.DIGITAL_CONTRACT_FORM_SCOPE + '*'} 
          aria-label={t.SCOPE}
        />
        <p className='inputs-text'>{t.DIGITAL_CONTRACT_DESCRIPTION_SCOPE}</p>
  
        <Input 
          ref={(el) => (inputRefs.current['fixturesPlaceOfConversion'] = el)}
          name='placeOfModification' 
          {...getAttrs('fixturesPlaceOfConversion')} 
          label={t.DIGITAL_CONTRACT_FORM_PLACE_OF_CONVERSION + '*'} 
          aria-label={t.PLACE_OF_CONVERSION}
        />
        <p className='inputs-text'>{t.DIGITAL_CONTRACT_DESCRIPTION_PLACE_OF_CONVERSION}</p>
  
        <Input 
          name='specialistCompany' 
          {...getAttrs('fixturesSpecialistCompany')} 
          label={t.DIGITAL_CONTRACT_FORM_SPECIALIST_COMPANY} 
          aria-label={t.SPECIALIST_COMPANY}
        />
        <p className='inputs-text'>{t.DIGITAL_CONTRACT_DESCRIPTION_SPECIALIST_COMPANY}</p>
  
        <h3 style={{ marginBottom: '20px' }} className='inputs-text'>{t.FIXTURES_HEAD_TWO}</h3>
  
        {fileUploadError && <Alert message={fileUploadError} type='error' style={{ marginTop: '12px', marginBottom: '12px' }} aria-live="assertive" role='alert' />}
  
        <Form.Group>
          <ImageUploader 
            label={t.FILE_UPLOAD} 
            files={tenantInstalationFiles} 
            onImageDrop={onImageDrop} 
            aria-label={t.FILE_UPLOAD}
          />
        </Form.Group>
  
        <Checkbox
          label={t['DIGITAL_CONTRACT_FORM_COST_ESTIMATE']}
          value={model.fixturesCostEstimate}
          onChange={e => setVal('fixturesCostEstimate', !model.fixturesCostEstimate)}
          aria-label={t.COST_ESTIMATE}
        />
  
        <Checkbox
          label={t['DIGITAL_CONTRACT_FORM_DETAILED_DRAWING']}
          value={model.fixturesDetailedDrawing}
          onChange={e => setVal('fixturesDetailedDrawing', !model.fixturesDetailedDrawing)}
          aria-label={t.DETAILED_DRAWING}
        />
  
        <Checkbox
          label={t['DIGITAL_CONTRACT_FORM_DESCRIPTION_OF_THE_MEASURE']}
          value={model.fixturesDescriptionOfTheMeasure}
          onChange={e => setVal('fixturesDescriptionOfTheMeasure', !model.fixturesDescriptionOfTheMeasure)}
          aria-label={t.DESCRIPTION_OF_THE_MEASURE}
        />
  
        <p className='input-para'>{t.FIXTURES_PARA_ONE}</p>
        <Input ref={(el) => (inputRefs.current['place'] = el)} autoComplete="address-level2" name='place' {...getAttrs('place')} label={t.DIGITAL_CONTRACT_FORM_PLACE + '*'} aria-label={t.PLACE} />
        <DateInput blurValidate={validatorBlur['date']} ref={(el) => (inputRefs.current['date'] = el)} name='date' value={model['date']} onChange={(date) => setVal('date', date)} validate={tenantInstallationsValidators['date']} label={t.DIGITAL_CONTRACT_FORM_DATE + '*'} aria-label={t.DATE} />
        <Form.Group className='actions text-center'>
          <div className='group'>
            <button
              className='button primary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                onSubmit(e)
              }}
              aria-label={t.SUBMIT_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_SEND}
            </button>
            <a
              href='/documents'
              className='button secondary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                DocumentStore.onCloseForm()
                navigate('/documents')
              }}
              style={{
                textDecoration: 'none',
                color: 'unset'
              }}
              aria-label={t.CANCEL_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_CANCEL}
            </a>
          </div>
        </Form.Group>
      </Form>
    </div>
  );
}

Fixtures.propTypes = {
  file: PropTypes.object.isRequired,
  contractStore: PropTypes.object
}

export default inject('contractStore')(observer(Fixtures))
